// ───────────────────────────────
// CONFIG
// ───────────────────────────────
// Endpoint da Netlify Function.
// URL absoluto — funciona tanto local como em produção (Shopify).
const WEBHOOK_URL = 'https://crmcombinehome.netlify.app/.netlify/functions/lead';

// ───────────────────────────────
// UTM TRACKING (first-touch)
// ───────────────────────────────
// Captura utm_* + click IDs (gclid, fbclid, msclkid, oaiq) da URL na primeira
// pageview da sessão. Mantém em sessionStorage para sobreviver a navegação
// entre páginas do mesmo separador. First-touch: só grava se ainda estiver vazio.
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'msclkid', 'oaiq_click_id'];
const UTM_STORAGE_KEY = 'ch_attribution';

function captureAttribution() {
  try {
    const stored = JSON.parse(sessionStorage.getItem(UTM_STORAGE_KEY) || '{}');
    const url = new URL(window.location.href);
    let updated = false;
    UTM_KEYS.forEach(k => {
      const v = url.searchParams.get(k);
      if (v && !stored[k]) { stored[k] = v; updated = true; }
    });
    // Fallback: capture landing URL + referrer on first touch (no UTMs)
    if (!stored.landing_url) { stored.landing_url = window.location.href; updated = true; }
    if (!stored.referrer && document.referrer) { stored.referrer = document.referrer; updated = true; }
    if (updated) sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(stored));
    return stored;
  } catch (e) { return {}; }
}

function getAttribution() {
  try { return JSON.parse(sessionStorage.getItem(UTM_STORAGE_KEY) || '{}'); }
  catch (e) { return {}; }
}

// Run immediately on script load
captureAttribution();

// ───────────────────────────────
// TRACKING (Meta Pixel + GA4)
// ───────────────────────────────
function trackEvent(eventName, params = {}) {
  // Meta Pixel
  try {
    if (typeof fbq === 'function') {
      if (eventName.startsWith('std:')) {
        // Eventos standard do Pixel (Lead, CompleteRegistration, etc.)
        fbq('track', eventName.replace('std:', ''), params);
      } else {
        // Eventos custom
        fbq('trackCustom', eventName, params);
      }
    }
  } catch (e) { console.warn('fbq error', e); }

  // Google Analytics 4
  try {
    if (typeof gtag === 'function') {
      gtag('event', eventName.replace('std:', '').replace(/[^a-zA-Z0-9_]/g, '_'), params);
    }
  } catch (e) { console.warn('gtag error', e); }
}

// Slide name map for tracking
const SLIDE_NAMES = {
  0: 'Start',
  1: 'Divisoes',
  2: 'Orcamento',
  3: 'Descricao',
  4: 'Contacto',
  5: 'Obrigado'
};

let TRACKED_SLIDES = new Set(); // não repetir tracking do mesmo slide

function trackSlideView(slideNum) {
  if (TRACKED_SLIDES.has(slideNum)) return;
  TRACKED_SLIDES.add(slideNum);
  const name = SLIDE_NAMES[slideNum] || 'Slide' + slideNum;
  // Evento STANDARD do Meta (ViewContent) — o passo vai no parâmetro,
  // para não inflacionar contadores nem distorcer a otimização de campanhas.
  trackEvent('std:ViewContent', {
    content_name:     'Formulário Decoração',
    content_type:     'lead_form',
    content_category: 'Step ' + slideNum + ' - ' + name,
    step:             slideNum,
    step_name:        name,
    form_name:        'Lead Decoração'
  });
}

// ───────────────────────────────
// I18N — translations (PT / EN)
// ───────────────────────────────
const I18N = {
  pt: {
    // Capa lateral
    leftEyebrow: 'ONLINE OU PRESENCIAL',
    leftTitle: 'Inicie agora a decoração da sua casa.',
    leftSubStrong: 'Chave na mão:',
    leftSubText: ' a sua casa, da concepção à conclusão.',
    leftSubHtml: '<strong>Chave na mão:</strong> a sua casa, da concepção à conclusão.',
    leftNote: 'Um profissional entrará em contacto.',
    // Slide 0 — start
    startEyebrow: 'Comece o seu projeto',
    startTitle: 'Clique em iniciar.',
    startTime: 'Demora cerca de 1 minuto',
    startBtn: 'Iniciar →',
    // Comum
    stepFmt: 'Etapa {n} de 4',
    btnContinue: 'Continuar →',
    btnBack: '← Voltar',
    btnSubmit: 'Quero submeter e ser contactado por um profissional.',
    btnSending: 'A enviar...',
    btnRetry: 'Tentar novamente →',
    submitError: 'Não foi possível enviar. Verifique a sua ligação e tente novamente.',
    // Slide 1 — divisões
    s1Title: 'Quais as divisões a decorar?',
    s1Sub: 'Pode selecionar múltiplas opções.',
    s1Helper: 'Na Combine Home não produzimos cozinhas.',
    optSala: 'Sala',
    optHall: 'Hall de Entrada',
    optQuarto: 'Quarto',
    opt2Quartos: '2 Quartos',
    opt3Quartos: '3 ou mais Quartos',
    optOutras: 'Outras divisões',
    // Slide 2 — orçamento
    s2Title: 'Qual o orçamento previsto?',
    s2Sub: 'A nossa equipa alinhará ideias de acordo com o orçamento para o seu projeto.',
    budgetBlockedFmt: 'Selecionou {n} {word} a decorar. Alguns intervalos de orçamento foram bloqueados por não serem suficientes.',
    budgetWordSingular: 'divisão',
    budgetWordPlural: 'divisões',
    budgetAbove50: 'Acima de 50.000€',
    // Slide 3 — descrição
    s4Title: 'Breve descrição do que pretende no seu projeto.',
    s4Placeholder: 'Ex: Apartamento novo, estilo moderno minimalista...',
    s4CheckHelper: 'Os Projetos de Decoração 3D não têm custo e são exclusivos para clientes que adquiram o mobiliário na Combine Home.',
    s4CheckLabel: 'Quero Projeto de Decoração 3D',
    s4LocLabel: 'Localização da habitação',
    s4LocPlaceholder: 'Ex: Porto, Vila Nova de Gaia',
    // Slide 4 — contacto
    s5Title: 'Os seus dados.',
    s5Sub: 'A nossa equipa entrará em contacto e estará ao seu lado em cada etapa do processo.',
    s5NomeLabel: 'Nome',
    s5NomePh: 'O seu nome',
    s5TelLabel: 'Telefone',
    s5TelPh: '+351 ...',
    s5EmailLabel: 'E-mail',
    s5EmailPh: 'exemplo@email.com',
    // Slide 5 — obrigado
    s6Title: 'Obrigado pela sua resposta.',
    s6Text: 'A nossa equipa entrará em contacto brevemente para iniciarmos o seu projeto juntos.',
    // Valores enviados no payload (mantemos PT internamente; só mostramos traduzidos)
    yes: 'Sim',
    no: 'Não'
  },
  en: {
    // Capa lateral
    leftEyebrow: 'ONLINE OR IN-PERSON',
    leftTitle: 'Start decorating your home today.',
    leftSubStrong: 'Turnkey service:',
    leftSubText: ' your home, from concept to completion.',
    leftSubHtml: '<strong>Turnkey service:</strong> your home, from concept to completion.',
    leftNote: 'A specialist will be in touch.',
    // Slide 0 — start
    startEyebrow: 'Start your project',
    startTitle: 'Click to start.',
    startTime: 'Takes about 1 minute',
    startBtn: 'Start →',
    // Common
    stepFmt: 'Step {n} of 4',
    btnContinue: 'Continue →',
    btnBack: '← Back',
    btnSubmit: 'Submit and get contacted by a specialist.',
    btnSending: 'Sending...',
    btnRetry: 'Try again →',
    submitError: 'We couldn\'t send your request. Please check your connection and try again.',
    // Slide 1 — rooms
    s1Title: 'Which rooms would you like to decorate?',
    s1Sub: 'You can select multiple options.',
    s1Helper: 'Combine Home does not produce kitchens.',
    optSala: 'Living Room',
    optHall: 'Entrance Hall',
    optQuarto: 'Bedroom',
    opt2Quartos: '2 Bedrooms',
    opt3Quartos: '3 or more Bedrooms',
    optOutras: 'Other rooms',
    // Slide 2 — budget
    s2Title: 'What is your estimated budget?',
    s2Sub: 'Our team will tailor ideas to fit the budget for your project.',
    budgetBlockedFmt: 'You selected {n} {word} to decorate. Some budget ranges have been disabled as they would not be sufficient.',
    budgetWordSingular: 'room',
    budgetWordPlural: 'rooms',
    budgetAbove50: 'Above €50,000',
    // Slide 3 — description
    s4Title: 'Brief description of what you want for your project.',
    s4Placeholder: 'E.g. New apartment, modern minimalist style...',
    s4CheckHelper: '3D Decoration Projects are free and exclusive to clients who purchase their furniture from Combine Home.',
    s4CheckLabel: 'I want a 3D Decoration Project',
    s4LocLabel: 'Property location',
    s4LocPlaceholder: 'E.g. Porto, Vila Nova de Gaia',
    // Slide 4 — contact
    s5Title: 'Your details.',
    s5Sub: 'Our team will be in touch and stand by your side at every step of the process.',
    s5NomeLabel: 'Name',
    s5NomePh: 'Your name',
    s5TelLabel: 'Phone',
    s5TelPh: '+351 ...',
    s5EmailLabel: 'E-mail',
    s5EmailPh: 'example@email.com',
    // Slide 5 — thank you
    s6Title: 'Thank you for your response.',
    s6Text: 'Our team will be in touch shortly so we can start your project together.',
    // Internal values (kept in PT for backend consistency)
    yes: 'Yes',
    no: 'No'
  }
};

// Detect language with priority cascade
function detectLang() {
  // 1. Shopify global variable
  try {
    if (typeof Shopify !== 'undefined' && Shopify.locale) {
      const sl = String(Shopify.locale).toLowerCase().slice(0, 2);
      if (I18N[sl]) return sl;
    }
  } catch (e) {}
  // 2. <html lang="">
  const htmlLang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
  if (I18N[htmlLang]) return htmlLang;
  // 3. URL parameter ?lang=
  const urlLang = new URLSearchParams(window.location.search).get('lang');
  if (urlLang && I18N[urlLang.toLowerCase().slice(0, 2)]) return urlLang.toLowerCase().slice(0, 2);
  // 4. Browser language
  const navLang = (navigator.language || 'pt').toLowerCase().slice(0, 2);
  if (I18N[navLang]) return navLang;
  // 5. Fallback
  return 'pt';
}

let CURRENT_LANG = detectLang();

// Translate one key, with optional placeholder substitution
function t(key, vars) {
  let str = (I18N[CURRENT_LANG] && I18N[CURRENT_LANG][key]) || I18N.pt[key] || key;
  if (vars) {
    Object.keys(vars).forEach(k => { str = str.replace('{' + k + '}', vars[k]); });
  }
  return str;
}

// Apply translations to all elements with data-i18n / data-i18n-ph / data-i18n-html
function applyTranslations() {
  document.documentElement.lang = CURRENT_LANG;
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    const vars = el.getAttribute('data-i18n-vars');
    let parsedVars = null;
    if (vars) { try { parsedVars = JSON.parse(vars); } catch (e) {} }
    el.textContent = t(key, parsedVars);
  });
  document.querySelectorAll('[data-i18n-html]').forEach(el => {
    el.innerHTML = t(el.getAttribute('data-i18n-html'));
  });
  document.querySelectorAll('[data-i18n-ph]').forEach(el => {
    el.setAttribute('placeholder', t(el.getAttribute('data-i18n-ph')));
  });
}

// Change language at runtime (called by the language switcher in the Shopify host page)
function setLang(lang) {
  const code = String(lang || '').toLowerCase().slice(0, 2);
  if (!I18N[code] || code === CURRENT_LANG) return;
  CURRENT_LANG = code;
  applyTranslations();
}
// Expose globally so the Shopify page can call window.setLang('en') when the user switches
window.setLang = setLang;

// Listen for storage events (in case Shopify uses localStorage to track locale)
window.addEventListener('storage', e => {
  if (e.key === 'shopify_locale' && e.newValue) setLang(e.newValue);
});

// ───────────────────────────────
// STATE
// ───────────────────────────────
const state = {
  currentSlide: 0,
  totalSlides: 6,
  divisoes: [],
  budget: null,
  budgetLevel: 0,
  inspiracoes: [],
  descricao: '',
  projeto3d: false,
  localizacao: '',
  nome: '',
  telefone: '',
  email: ''
};

// ───────────────────────────────
// SLIDE 1 — DIVISÕES (multi-select)
// ───────────────────────────────
document.querySelectorAll('#divisoes-options .option').forEach(el => {
  el.addEventListener('click', () => {
    el.classList.toggle('selected');
    state.divisoes = Array.from(document.querySelectorAll('#divisoes-options .option.selected'))
      .map(o => o.dataset.value);
    document.getElementById('btn-next-1').disabled = state.divisoes.length === 0;
    updateBudgetRestrictions();
  });
});

// Count total rooms for budget limit purposes:
// '2 Quartos' = 2, '3 ou mais Quartos' = 3, 'Outras divisões' = 0 (neutral), others = 1
function countRooms() {
  let n = 0;
  state.divisoes.forEach(d => {
    if (d === '2 Quartos') n += 2;
    else if (d === '3 ou mais Quartos') n += 3;
    else if (d === 'Outras divisões') n += 0; // neutral — doesn't influence budget
    else n += 1;
  });
  return n;
}

// First budget option shifts to 7.000€ — 10.000€ when Sala is selected
// together with any other room. Sala alone (or Sala not selected) keeps the
// original 5.000€ — 10.000€ range.
function updateFirstBudgetLabel() {
  const firstOpt = document.querySelector('#budget-options .option[data-budget="1"]');
  if (!firstOpt) return;
  const hasSala = state.divisoes.indexOf('Sala') !== -1;
  const salaPlusOther = hasSala && state.divisoes.length > 1;
  const newValue = salaPlusOther ? '7.000 - 10.000€' : '5.000 - 10.000€';
  const newLabel = salaPlusOther ? '7.000€ — 10.000€' : '5.000€ — 10.000€';
  const oldValue = firstOpt.dataset.value;
  if (oldValue === newValue) return;
  firstOpt.dataset.value = newValue;
  const span = firstOpt.querySelector('span');
  if (span) span.textContent = newLabel;
  if (firstOpt.classList.contains('selected') && state.budget === oldValue) {
    state.budget = newValue;
  }
}

// Disable budget options that can't fit the selected room count
function updateBudgetRestrictions() {
  updateFirstBudgetLabel();
  const totalRooms = countRooms();
  const helper = document.getElementById('budget-helper');
  let anyBlocked = false;

  document.querySelectorAll('#budget-options .option').forEach(opt => {
    const max = parseInt(opt.dataset.maxRooms);
    if (totalRooms > max) {
      opt.classList.add('disabled');
      opt.classList.remove('selected');
      anyBlocked = true;
      // if the currently selected budget is now blocked, clear it
      if (state.budget === opt.dataset.value) {
        state.budget = null;
        state.budgetLevel = 0;
        document.getElementById('btn-next-2').disabled = true;
      }
    } else {
      opt.classList.remove('disabled');
    }
  });

  // Show helper message if any option got blocked
  if (anyBlocked && helper) {
    helper.style.display = 'block';
    helper.innerText = t('budgetBlockedFmt', {
      n: totalRooms,
      word: totalRooms === 1 ? t('budgetWordSingular') : t('budgetWordPlural')
    });
  } else if (helper) {
    helper.style.display = 'none';
  }
}

// ───────────────────────────────
// SLIDE 2 — BUDGET (single-select)
// ───────────────────────────────
document.querySelectorAll('#budget-options .option').forEach(el => {
  el.addEventListener('click', () => {
    if (el.classList.contains('disabled')) return;
    document.querySelectorAll('#budget-options .option').forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
    state.budget = el.dataset.value;
    state.budgetLevel = parseInt(el.dataset.budget);
    document.getElementById('btn-next-2').disabled = false;
  });
});

// ───────────────────────────────
// SLIDE 3 — TEXT INPUTS
// ───────────────────────────────
function checkSlide3() {
  const desc = document.getElementById('descricao').value.trim();
  const loc = document.getElementById('localizacao').value.trim();
  state.descricao = desc;
  state.localizacao = loc;
  document.getElementById('btn-next-3').disabled = !(desc.length > 0 && loc.length > 0);
}

// ───────────────────────────────
// SLIDE 4 — CONTACT
// ───────────────────────────────
function checkSlide4() {
  const nome = document.getElementById('nome').value.trim();
  const tel = document.getElementById('telefone').value.trim();
  const email = document.getElementById('email').value.trim();
  state.nome = nome;
  state.telefone = tel;
  state.email = email;
  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  document.getElementById('btn-submit').disabled = !(nome.length > 1 && tel.length > 5 && emailValid);
}

// ───────────────────────────────
// NAV
// ───────────────────────────────
function showSlide(n) {
  const slides = document.querySelectorAll('.slide');
  slides.forEach(s => {
    s.classList.remove('active', 'exit-left');
  });
  const next = document.querySelector(`[data-slide="${n}"]`);
  if (next) next.classList.add('active');
  state.currentSlide = n;
  updateProgress();
  // Track step view
  trackSlideView(n);
  // Scroll so the question is at the top of the viewport.
  // On mobile the hero image (380px) sits above the slides container (.right).
  // We scroll to the top of .right so the question sits right under the hero,
  // not below the screen. On desktop, .right is already at the top, so no-op.
  const right = document.querySelector('.right');
  if (right) {
    try {
      right.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {
      const y = right.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo(0, y);
    }
  }
  // Reset internal slide scroll (desktop, when slide content overflows)
  if (next && typeof next.scrollTo === 'function') {
    try { next.scrollTo({ top: 0, behavior: 'smooth' }); }
    catch (e) { next.scrollTop = 0; }
  }
}

function nextSlide() {
  if (state.currentSlide < state.totalSlides - 1) {
    showSlide(state.currentSlide + 1);
  }
}

function prevSlide() {
  if (state.currentSlide > 0) {
    showSlide(state.currentSlide - 1);
  }
}

function updateProgress() {
  const dots = document.querySelectorAll('.progress-dot');
  dots.forEach((dot, i) => {
    dot.classList.remove('active', 'done');
    if (i < state.currentSlide) dot.classList.add('done');
    if (i === state.currentSlide) dot.classList.add('active');
  });
}

// ───────────────────────────────
// SUBMIT
// ───────────────────────────────
async function submitForm() {
  const btn = document.getElementById('btn-submit');
  btn.disabled = true;
  btn.innerText = t('btnSending');

  const attribution = getAttribution();
  const payload = {
    timestamp: new Date().toISOString(),
    divisoes: state.divisoes.join(', '),
    orcamento: state.budget,
    inspiracoes: '-',
    descricao: state.descricao,
    projeto3d: state.projeto3d ? 'Sim' : 'Não',
    localizacao: state.localizacao,
    nome: state.nome,
    telefone: state.telefone,
    email: state.email,
    origem: (window._leadFormOrigem || (document.querySelector('.ch-lead-form') && document.querySelector('.ch-lead-form').dataset.formLabel) || 'Página Projeto - Inicio'),
    lang: CURRENT_LANG,
    // Attribution (first-touch UTMs + click IDs from the session)
    utm_source: attribution.utm_source || '',
    utm_medium: attribution.utm_medium || '',
    utm_campaign: attribution.utm_campaign || '',
    utm_content: attribution.utm_content || '',
    utm_term: attribution.utm_term || '',
    gclid: attribution.gclid || '',
    fbclid: attribution.fbclid || '',
    msclkid: attribution.msclkid || '',
    oaiq_click_id: attribution.oaiq_click_id || '',
    landing_url: attribution.landing_url || '',
    referrer: attribution.referrer || ''
  };

  try {
    const response = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok || !result.ok) {
      throw new Error(result.error || 'Falha no servidor');
    }

    // ─── TRACKING DA CONVERSÃO ───
    // Meta Pixel: Lead + CompleteRegistration (eventos standard)
    trackEvent('std:Lead', {
      content_name: 'Formulário Decoração',
      content_category: state.divisoes.join(', '),
      value: 1,
      currency: 'EUR'
    });
    trackEvent('std:CompleteRegistration', {
      content_name: 'Formulário Decoração',
      status: 'completed',
      value: 1,
      currency: 'EUR'
    });
    // GA4: generate_lead (evento standard de conversão)
    if (typeof gtag === 'function') {
      gtag('event', 'generate_lead', {
        currency: 'EUR',
        value: 1,
        form_name: 'Lead Decoração',
        divisoes: state.divisoes.join(', '),
        orcamento: state.budget,
        projeto_3d: state.projeto3d ? 'Sim' : 'Não'
      });
    }
    // ChatGPT Ads: lead_created
    try {
      if (typeof oaiq === 'function') {
        oaiq('measure', 'lead_created', { type: 'customer_action' });
      }
    } catch (e) { console.warn('oaiq error', e); }
    // ─── /TRACKING ───

    // Success — advance to thank-you slide
    nextSlide();

  } catch (err) {
    console.error('Submission error', err);
    btn.disabled = false;
    btn.innerText = t('btnRetry');
    alert(t('submitError'));
  }
}

// ─── ORIGEM ATTRIBUTION ───
// Real user click on the main form's Iniciar button resets origem to this
// form's data-form-label. CTA programmatic .click() has isTrusted=false so
// the CTA-set origem (Meio / Fim) is preserved.
(function() {
  var _mainForm = document.querySelector('.ch-lead-form');
  if (!_mainForm) return;
  var _initBtn = _mainForm.querySelector('.start-content .btn');
  if (!_initBtn) return;
  _initBtn.addEventListener('click', function(e) {
    if (e.isTrusted) {
      window._leadFormOrigem = _mainForm.dataset.formLabel || 'Página Projeto - Inicio';
    }
  });
})();

// init
applyTranslations();
updateProgress();

// ─── TRACKING INICIAL ───
// O utilizador chegou ao formulário (slide 0).
// trackSlideView(0) dispara ViewContent (standard) com o passo no parâmetro.
trackSlideView(0);
// ─── /TRACKING INICIAL ───
